import { useEffect } from 'react'
import { areEq, getStoredValue, storeValue } from './utils/localStrorageUtils'

/**
 * Custom hook to manage the beta workspace flag using url query parameters.
 * @param location - Optional query string containing the beta workspace flag.
 * @returns An object containing the beta workspace flag.
 */
export const useBetaWorkspaceFlag = (location?: string) => {
    const isBetaWorkspaceEnabled = areEq(
        getStoredValue('enableBetaWorkspace')?.toString(),
        'true'
    )

    // if no location is provided, return the persisted value
    if (!location) {
        return { isBetaWorkspaceEnabled }
    }

    useEffect(() => {
        // else, check the query params and update the persisted value
        const queryParams = new URLSearchParams(location)
        const enableBetaWorkspace = queryParams.get('enableBetaWorkspace')

        if (enableBetaWorkspace) {
            const parsedValue =
                areEq(enableBetaWorkspace, 'true') ||
                areEq(enableBetaWorkspace, '1')

            // persist enableBetaWorkspace in localStorage
            storeValue('enableBetaWorkspace', parsedValue)
        }
    }, [location])

    return { isBetaWorkspaceEnabled }
}
